<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-8 card-header-search-box">
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="initList">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                            <button class="all-btn add-btn m-0" @click="getCurrencyRateModal">
                              Валюта курсларини олиш
                            </button>
                          </div>

                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                              <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Валюта номи</th>
                                  <th>Валюта коди</th>
                                  <th>Валюта курси санаси</th>
                                  <th>Валюта курси</th>
                              </tr>
                              </thead>
                              <tbody v-if="!loading && results && results.data">
                              <tr v-for="result in results.data" :key="result.id">
                                  <td>{{result.id}}</td>
                                  <td>
                                      <div class="text-info">{{result.ccode === 'GOLD' ? 'Олтин (31.1034769g)' : result.cuzName}}</div>
                                  </td>
                                  <td>
                                      <div class="font-weight-bold">{{result.ccode}}</div>
                                  </td>
                                  <td>
                                      <div class="font-weight-bold">{{result.currencyDate}}</div>
                                  </td>
                                  <td>
                                      <span v-if="result.ccode !== 'GOLD' && result.ccode !== 'SILVER'">{{result.crate | currency('', 0, { thousandsSeparator: ' ' })}} сўм</span>
                                      <span v-if="result.ccode === 'GOLD' || result.ccode === 'SILVER'">{{result.metalRate | currency('', 0, { thousandsSeparator: ' ' })}} USD</span>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CurrencyRateByDate/>
        </div>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import CurrencyRateByDate from '@/views/config/currency/CurrencyRateByDate';

    export default {
        name: "CurrencyRateList",
        components: {
            'b-pagination': bPagination,
            CurrencyRateByDate: CurrencyRateByDate
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        computed: {
            addAssetUrl() {
                return '/asset/new';
            },
            getCurrencyRate() {
                return '/currency/get-by-date';
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('currency/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            getCurrencyRateModal() {
                this.$eventBus.$emit('getCurrencyRateModal');
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('currencyChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>
